/** Destino do clique em Pendências. Consulta direta, sem cadeia de condições. */
export const PENDENCIAS_POR_PERFIL: Record<string, string> = {
  admin: '/Admin',
  compras: '/AprovSuppliers',
  contabilidade: '/AprovContabil',
  tecnologia: '/minhas-requisicoes',
  comunicacao: '/minhas-requisicoes',
  sem_usuario: '/minhas-requisicoes',
};

export function rotaPendencias(perfil: string | null | undefined): string | null {
  const chave = (perfil || '').trim().toLowerCase();
  return PENDENCIAS_POR_PERFIL[chave] ?? null;
}
